const BUTTON_SELECTOR = '.bosp-liveagent-button';
const LAUNCHER_CLASS = 'liveagent-scroll-launcher';
const HIDDEN_CLASS = 'liveagent-scroll-launcher--hidden';
const MIN_SCROLL_TOP = 100;
const DIRECTION_THRESHOLD = 8;

let lastScrollTop = document.scrollingElement?.scrollTop ?? 0;
let isHidden = false;
let scrollFrameId = null;
const launcherElements = new Set();

/**
 * Registers LiveAgent's generated wrapper around a custom button.
 * @param {Element} button
 */
function registerLauncher(button) {
  const parent = button.parentElement;
  const launcher = parent && parent !== document.body ? parent : button;

  launcher.classList.add(LAUNCHER_CLASS);
  launcher.classList.toggle(HIDDEN_CLASS, isHidden);
  launcherElements.add(launcher);
}

/**
 * Finds custom buttons within a newly added DOM subtree.
 * @param {Document|Element} root
 */
function discoverLaunchers(root) {
  if (root instanceof Element && root.matches(BUTTON_SELECTOR)) {
    registerLauncher(root);
  }

  for (const button of root.querySelectorAll(BUTTON_SELECTOR)) {
    registerLauncher(button);
  }
}

function setLauncherHidden(hidden) {
  if (hidden === isHidden) return;

  isHidden = hidden;

  for (const launcher of launcherElements) {
    if (!launcher.isConnected) {
      launcherElements.delete(launcher);
      continue;
    }

    launcher.classList.toggle(HIDDEN_CLASS, hidden);
  }
}

function updateLauncherVisibility() {
  scrollFrameId = null;

  const scrollTop = Math.max(document.scrollingElement?.scrollTop ?? 0, 0);
  const delta = scrollTop - lastScrollTop;

  if (scrollTop <= MIN_SCROLL_TOP) {
    setLauncherHidden(false);
    lastScrollTop = scrollTop;
    return;
  }

  if (Math.abs(delta) < DIRECTION_THRESHOLD) return;

  setLauncherHidden(delta > 0);
  lastScrollTop = scrollTop;
}

function handleScroll() {
  if (scrollFrameId !== null) return;

  scrollFrameId = requestAnimationFrame(updateLauncherVisibility);
}

const observer = new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node instanceof Element) discoverLaunchers(node);
    }
  }
});

observer.observe(document.documentElement, {
  childList: true,
  subtree: true,
});

discoverLaunchers(document);
document.addEventListener('scroll', handleScroll, { passive: true });
